export const SUGGESTION_PAGE_INPUT_CLICK = "Suggestion_Page_Input_Click";
export const SUGGESTION_PAGE_TEXTAREA_CLICK  ="Suggestion_Page_Textarea_Click";
export const SUGGESTION_PAGE_SUBMIT_BTN_CLICK ="Suggestion_Page_Submit_Btn_Click"

export const SUPPORT_PAGE_LOADED = "Support_Page_Loaded"